import { createLucideIcon } from "lucide-react";

export const StopWatch = createLucideIcon(
    "StopWatch",
    [
        [
            "path",
            {
                d: "M11.9987 3.6667L12.6654 3",
                key: "367at5",
            },
        ],
        [
            "path",
            {
                d: "M3.332 3L3.9987 3.6667",
                key: "d7ubt",
            },
        ],
        [
            "path",
            {
                d: "M6.66797 1.33325H9.33464",
                key: "1rp4tg",
            },
        ],
        [
            "path",
            {
                d: "M8 2.33325V1.33325",
                key: "v31rwa",
            },
        ],
        [
            "path",
            {
                d: "M8 6.33325V8.99992L9.33333 10.3333",
                key: "1t31ew",
            },
        ],
        [
            "circle",
            {
                cx: "8",
                cy: "8.66675",
                key: "q2tgta",
                r: "6",
            },
        ],
    ],
);
